import * as types from './types';

function setPredictions(id, predictions) {
    return {
        meta: id,
        payload: predictions,
        type: types.SET_PREDICTIONS,
    };
}

function setPlaceDetails(id, placeDetails) {
    return {
        meta: id,
        payload: placeDetails,
        type: types.SET_PLACE_DETAILS,
    };
}

export {
    setPlaceDetails,
    setPredictions,
};
